export default {

  dev: {
    //api域名
    host: "http://admin.177.com/api",
    //前端域名
    domain: "http://www.177.com",

    //大文件上传接口
    down_domain: 'http://down.cms.com/uploadFile',
    // down_domain:'https://down.fl21.cn/uploadFile',

    //普通文件上传接口
    // file_upload_url:"http://www.down.com/uploadNormal",
    // file_upload_url: "http://down.cms.com/uploadNormal",
    file_upload_url:"https://down.fl21.cn/uploadNormal",

    //资源文件域名，图片什么的
    // static_url: "http://down.cms.com"
    static_url:"https://down.fl21.cn"
    // static_url:"http://www.down.com"


  },
  pro: {
    host: "https://admin.177xz.com/api",
    domain: "https://www.177xz.com",
    //大文件上传接口
    down_domain: 'https://down.fl21.cn/uploadFile',
    //普通文件上传接口
    file_upload_url: "https://down.fl21.cn/uploadNormal",

    //资源文件域名，图片什么的
    // static_url:"https://down.522gg.com"
    static_url: "https://down.177xz.com"

  },


  // pro:{
  //   host:"https://admin.7149.com.cn/api",
  //   domain:"https://www.7149.com.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.522gg.com/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.522gg.com/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.522gg.com"
  //
  // }

  // pro:{
  //   host:"https://admin.7149gg.com/api",
  //   domain:"https://www.7149gg.com",
  //   //大文件上传接口
  //   down_domain:'https://down.522gg.com/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.522gg.com/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.522gg.com"
  //
  // }



  // pro:{
  //   host:"https://admin.737g.com/api",
  //   domain:"https://www.737g.com",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.737g.com"
  //
  // }


  // pro:{
  //   host:"https://admin.54119.com.cn/api",
  //   domain:"https://www.54119.com.cn",
  //   //大文件上传接口
  //   down_domain:'https://admin.54119.com.cn/api/admin/upload/uploadForBigFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://admin.54119.com.cn/api/admin/upload/uploadForList",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://www.54119.com.cn"
  //
  // }

  // pro:{
  //   host:"https://admin.web6688.com/api",
  //   domain:"https://www.web6688.com",
  //   //大文件上传接口
  //   down_domain:'https://admin.web6688.com/api/admin/upload/uploadForBigFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://admin.web6688.com/api/admin/upload/uploadForList",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://www.web6688.com"
  //
  // }


  // pro:{
  //   host:"https://admin.00270.com.cn/api",
  //   domain:"https://www.00270.com.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.00270.com.cn"
  //
  // }

  // pro:{
  //   host:"https://admin.00270.com.cn/api",
  //   domain:"https://www.00270.com.cn",
  //   //大文件上传接口
  //   down_domain:'https://admin.00270.com.cn/api/admin/upload/uploadForBigFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://admin.00270.com.cn/api/admin/upload/uploadForList",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://www.00270.com.cn"
  //
  // }


  // pro:{
  //   host:"https://admin.qqzonecn.com/api",
  //   domain:"https://www.qqzonecn.com",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.qqzonecn.com"
  //
  // }



  // pro:{
  //   host:"https://admin.bidjp.com/api",
  //   domain:"https://www.bidjp.com",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.bidjp.com"
  //
  // }

  // pro:{
  //   host:"https://admin.gyjinye.com/api",
  //   domain:"https://www.gyjinye.com",
  //   //大文件上传接口
  //   down_domain:'https://admin.gyjinye.com/api/admin/upload/uploadForBigFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://admin.gyjinye.com/api/admin/upload/uploadForList",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://www.gyjinye.com"
  //
  // }



  // pro: {
  //   host: "https://admin.sharedblog.cn/api",
  //   domain: "https://www.sharedblog.cn",
  //   //大文件上传接口
  //   down_domain: 'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url: "https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   // static_url:"https://down.522gg.com"
  //   static_url: "https://down.sharedblog.cn"
  //
  // },

  // pro: {
  //   host: "https://admin.web6688.com/api",
  //   domain: "https://www.web6688.com",
  //   //大文件上传接口
  //   down_domain: 'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url: "https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   // static_url:"https://down.522gg.com"
  //   static_url: "https://down.web6688.com"
  //
  // },

  // pro:{
  //   host:"https://admin.fl21.cn/api",
  //   domain:"https://www.fl21.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.fl21.cn"
  //
  // },


  // pro:{
  //   host:"http://bk.baolinxuan.cn/api",
  //   domain:"http://www.baolinxuan.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.fl21.cn"
  //
  // }


  // pro:{
  //   host:"http://bk.greenholiday.cn/api",
  //   domain:"http://www.greenholiday.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.fl21.cn"
  //
  // }


  // pro:{
  //   host:"http://bk.qdgrasp.cn/api",
  //   domain:"http://www.qdgrasp.cn",
  //   //大文件上传接口
  //   down_domain:'https://down.fl21.cn/uploadFile',
  //   //普通文件上传接口
  //   file_upload_url:"https://down.fl21.cn/uploadNormal",
  //
  //   //资源文件域名，图片什么的
  //   static_url:"https://down.fl21.cn"
  //
  // }



}



// WEBPACK FOOTER //
// ./src/env.js